import { ReactNode, useState } from 'react';

import { EnumDevice, PropsWithClassName } from '@/types';
import { cn } from '@/utils';

type Props = PropsWithClassName<{
  message: ReactNode;
  variant: EnumDevice;
  context?: string;
  onCloseAction?: () => void;
}>;

export const Alert = ({
  className,
  message,
  variant,
  onCloseAction,
}: Props) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(!isVisible);
    if (onCloseAction) {
      onCloseAction();
    }
  };

  return (
    <>
      {isVisible && (
        <div
          className={cn(
            'flex items-center justify-between bg-gdt-blue rounded-lg text-white py-2 text-xs lg:text-sm px-2 m-auto',
            className
          )}
        >
          <svg
            className="lg:block ms-2 hidden"
            fill="none"
            height="20"
            viewBox="0 0 20 20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clipRule="evenodd"
              d="M8.77446 1.90259C9.14887 1.69179 9.57128 1.58105 10.001 1.58105C10.4306 1.58105 10.853 1.69179 11.2274 1.90259C11.6019 2.11338 11.9156 2.41712 12.1385 2.78448L12.1409 2.78844L19.1992 14.5718L19.2059 14.5833C19.4242 14.9613 19.5397 15.3899 19.541 15.8264C19.5422 16.263 19.4291 16.6922 19.2129 17.0714C18.9967 17.4507 18.685 17.7667 18.3088 17.9881C17.9326 18.2095 17.5049 18.3285 17.0684 18.3333L17.0593 18.3334L2.93346 18.3333C2.49696 18.3285 2.06932 18.2095 1.6931 17.9881C1.31687 17.7667 1.00516 17.4507 0.788994 17.0714C0.572825 16.6922 0.459725 16.263 0.460947 15.8264C0.46217 15.3899 0.577672 14.9613 0.795961 14.5833L0.80273 14.5718L7.86106 2.78845L8.57594 3.21667L7.86345 2.78448C8.08629 2.41712 8.40005 2.11338 8.77446 1.90259ZM9.28946 3.64721L2.23653 15.4215C2.16554 15.5464 2.12801 15.6874 2.12761 15.8311C2.1272 15.9766 2.1649 16.1197 2.23696 16.2461C2.30901 16.3725 2.41291 16.4779 2.53832 16.5517C2.66264 16.6248 2.80378 16.6644 2.94795 16.6667H17.054C17.1981 16.6644 17.3393 16.6248 17.4636 16.5517C17.589 16.4779 17.6929 16.3725 17.7649 16.2461C17.837 16.1197 17.8747 15.9766 17.8743 15.8311C17.8739 15.6875 17.8364 15.5464 17.7654 15.4216L10.7135 3.64886C10.7131 3.64831 10.7128 3.64776 10.7124 3.64721C10.6382 3.52549 10.534 3.42485 10.4098 3.3549C10.285 3.28463 10.1442 3.24772 10.001 3.24772C9.85773 3.24772 9.71692 3.28463 9.59212 3.3549C9.46788 3.42485 9.36368 3.52549 9.28946 3.64721Z"
              fill="white"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M9.16602 14.1666C9.16602 13.7063 9.53911 13.3333 9.99935 13.3333H10.0077C10.4679 13.3333 10.841 13.7063 10.841 14.1666C10.841 14.6268 10.4679 14.9999 10.0077 14.9999H9.99935C9.53911 14.9999 9.16602 14.6268 9.16602 14.1666Z"
              fill="white"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M9.99935 6.66675C10.4596 6.66675 10.8327 7.03984 10.8327 7.50008V10.8334C10.8327 11.2937 10.4596 11.6667 9.99935 11.6667C9.53911 11.6667 9.16602 11.2937 9.16602 10.8334V7.50008C9.16602 7.03984 9.53911 6.66675 9.99935 6.66675Z"
              fill="white"
              fillRule="evenodd"
            />
          </svg>

          <div className="flex-1 lg:ms-3 tracking-[.2px]">{message}</div>

          <button className="" onClick={() => handleClose()}>
            <svg
              fill="none"
              height="28"
              transform={`scale(${variant === EnumDevice.Desktop ? 1.5 : 1})`}
              viewBox="0 0 28 28"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.3752 18.4067L9.62476 9.65625M9.62476 18.4067L18.3752 9.65625"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={variant === EnumDevice.Desktop ? 1.5 : 2}
              />
            </svg>
          </button>
        </div>
      )}
    </>
  );
};
